// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useCallback, useEffect, useState } from 'react';

import { UseQueryResult } from '@tanstack/react-query';

// Take in a value to watch for
// Take in a query function
// Take in a (x to query for)

export default function usePollingUpdater(
  queryClient: () => UseQueryResult<any, unknown>,
  intervalCount = 8
) {
  const intervalMs = 2500;
  const { data, refetch, isLoading } = queryClient();
  const [initialData, setInitialData] = useState(null);

  // If interval count got lost, set it to 0 so we exit.
  const interval = async (currentInterval = 0) => {
    const { data: newData, error } = await refetch();

    console.log(newData, initialData);
    console.log('error?', error);
    // Exit poller on errors
    if (error) {
      return;
    }

    if (newData !== initialData) {
      return;
    }

    if (currentInterval <= 0) {
      return;
    }
    console.debug('now we are at', currentInterval--);
    setTimeout(interval, intervalMs, currentInterval--);
  };

  const pollQuery = useCallback(async () => {
    console.log('usePollingUpdate: pollquery()');
    const { data: newData } = await refetch();
    if (newData === initialData) {
      // Account for previous poll
      setTimeout(interval, intervalMs, intervalCount - 1);
    }
  }, [initialData]);

  // Update our initial data here.
  useEffect(() => {
    if (initialData == null && !isLoading) setInitialData(data);
  }, [isLoading]);

  return { pollQuery };
}
